import { useState, useEffect } from 'react';

type TypewriterState = 'typing' | 'pausing' | 'deleting';

export const useTypewriter = (words: string[], typingSpeed = 150, pauseDuration = 2000) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [state, setState] = useState<TypewriterState>('typing');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    const currentWord = words[currentWordIndex];

    const type = () => {
      if (isDeleting) {
        // Deleting text
        if (currentText === '') {
          setIsDeleting(false);
          setCurrentWordIndex((prev) => (prev + 1) % words.length);
        } else {
          setCurrentText((text) => text.slice(0, -1));
        }
      } else {
        // Typing text
        if (currentText === currentWord) {
          // Word is complete, pause then start deleting
          timeout = setTimeout(() => {
            setIsDeleting(true);
          }, pauseDuration);
          return;
        }
        setCurrentText(currentWord.slice(0, currentText.length + 1));
      }
    };

    timeout = setTimeout(type, isDeleting ? typingSpeed / 2 : typingSpeed);

    return () => clearTimeout(timeout);
  }, [currentText, currentWordIndex, isDeleting, words, typingSpeed, pauseDuration]);

  return { 
    text: currentText, 
    isTyping: true 
  };
};